export const config = {
  title: 'Olympic Dependable Maintenance Corp.',
  meta: {
    description:
      'Olympic Dependable Maintenance Corp. is your trusted cleaning and maintenance service provider, offering personalized services and expert guidance.',
    keywords: [
      'Cleaning Services',
      'Maintenance Services',
      'Commercial Cleaning',
      'Office Cleaning',
      'Carpet Care',
      'Olympic Dependable Maintenance Corp.',
    ],
    author: 'Olympic Dependable Maintenance Corp.',
    canonicalUrl: 'https://olympicdmaint.com/',
  },
  sections: {
    header: {
      businessName: 'Olympic Dependable Maintenance Corp.',
    },
    sectionB: {
      heroTitle: "Olympic Dependable Maintenance Corp.",
      heroSubtitle: "Providing Professional Cleaning and Maintenance Services",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "6133196247",
      phoneLabel: "(613) 319-6247",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2164568178/photo/office-deep-clean-team.jpg?s=612x612&w=0&k=20&c=NzfC2PzLs1jMBClZPtmVnBmWSrTkt9X8CYxUwDEAgHM=",
      cardData: [
        {
          title: "Personalized Service",
          description:
            "We provide customized cleaning and maintenance solutions tailored to your specific needs.",
        },
        {
          title: "Flexibility and Availability",
          description:
            "Our team works around your schedule to deliver seamless and convenient services.",
        },
        {
          title: "Expert Guidance",
          description:
            "Benefit from years of experience and expertise in cleaning and maintenance services.",
        },
      ],
      description:
        "Olympic Dependable Maintenance Corp. offers a wide range of services including commercial cleaning, office cleaning, carpet care, and more, ensuring a spotless and well-maintained environment.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of professional cleaning and maintenance services tailored to meet your needs.',
      cards: [
        {
          title: 'Commercial Cleaning',
          description:
            'Our team provides top-notch commercial cleaning services to keep your business environment clean and inviting.',
          imageSrc: 'localImageOne',
          imageAlt: 'Commercial Cleaning',
        },
        {
          title: 'Office Cleaning',
          description:
            'We deliver thorough office cleaning services customized for your workspace, ensuring a productive and healthy environment.',
          imageSrc: 'localImageTwo',
          imageAlt: 'Office Cleaning',
        },
        {
          title: 'Carpet Care',
          description:
            'Our experienced professionals offer expert carpet cleaning services to maintain a fresh and polished look.',
          imageSrc: 'localImageThree',
          imageAlt: 'Carpet Care',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Stripping/Waxing',
        'Construction Clean-Up',
        'Kitchen Care',
        'Bathroom & Bedroom Care',
        'Power Washed Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://olympicdmaint.com/wp-content/uploads/2020/07/iris.jpg',
        alt: 'Olympic Dependable Maintenance Corp. Team',
      },
      aboutText: [
        'Olympic Dependable Maintenance corp is a family-owned business founded in 2005.',
        'We are established with the sole purpose of performing the highest level of service in the industry. We know that you have a ton of choices when it comes to Cleaning Service. We are confident that Olympic Dependable Maintenance corp will exceed all your expectations. Our competitive pricing and excellent team of cleaning professionals continue to exceed our client expectation week after week.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Olympic Dependable Maintenance Corp. Logo',
      businessName: 'Olympic Dependable Maintenance Corp.',
      contact: {
        phone: '6133196247',
        phoneLabel: '(613) 319-6247',
        email: 'info@olympicdmaint.com',
        website: 'https://olympicdmaint.com/',
        address: '600 Johnson Ave Suite E2, Bohemia, NY 11716',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: 'https://www.facebook.com/OLYMPICDMAINT/',
        twitter: null,
        tiktok: null,
        instagram: 'https://www.instagram.com/olympiccleaning_/',
        youtube: null,
      },
    },
    sectionF: {
      address: '600 Johnson Ave Suite E2, Bohemia, NY 11716',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.5105881886655!2d-73.1153416844882!3d40.78364387918219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884039afdf85df3d%3A0x73dc541ee2fae5e0!2sJohnson%20Ave%2C%20Bohemia%2C%20NY%2011716!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;
